import {
	ClassicyAboutWindow,
	type ClassicyAboutWindowProps,
} from "./ClassicyAboutWindow";

export const getClassicyAboutWindow = (props: ClassicyAboutWindowProps) => {
	return <ClassicyAboutWindow {...props} />;
};
